(function dbaDetailControllerDefinition() {
    'use strict';

    angular.module('Dba')
        .controller('dbaDetailController', [
            '$filter', '$state', '$scope', '$stateParams', 'dbaService', 'authExtend', '$translate', 'errorsExtend', 'alerts',
            function dbaDetailController($filter, $state, $scope, $stateParams, dbaService, auth, $translate, errors, alerts) {

                $scope.canEdit = auth.isInRole('EDIT AND DELETE INDEX');

                $scope.load = function () {
                    $scope.key = $stateParams.key;
                    $scope.id = $stateParams.id;
                    $scope.editableIndex = "";
                    $scope.editableIndexPosition = -1;
                    $scope.editableCollection = null;

                    dbaService.get($scope.key, $scope.id).then(function (result) {
                        $scope.collections = result.value;
                        var foundIndex;
                        for (var i = 0; i < $scope.collections[0].indexes.length; i++) {
                            foundIndex = $scope.collections[0].indexes[i].search("\"name\" : \"_id_\"");
                            if (foundIndex > -1) {
                                $scope.indexId = i;
                            }
                        }
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.cancel = function () {
                    $state.goBack();
                };

                $scope.editIndex = function (index, position, collection) {
                    $scope.editableIndex = index;
                    $scope.editableIndexPosition = position;
                    $scope.editableCollection = collection;
                    $('#editIndexModal').modal('show');
                };

                $scope.deleteIndex = function (index, position, collection) {
                    return $translate(['Warning', 'MongoIndexDeleteConfirmText', 'Yes', 'No']).then(function (translated) {
                        return alerts.confirm(translated.Warning, translated.MongoIndexDeleteConfirmText, translated.Yes, translated.No).then(function getOk(result) {
                            if (result) {
                                var key = $scope.key;
                                if ($scope.key == "OU") {
                                    key = collection.tipo === "DocumentType" ? "OUD" : "OUC";
                                }

                                dbaService.delete(key, $scope.id, index).then(function (result) {
                                    errors.showSuccess('DeleteIndexSucces');
                                    $scope.collections = null;
                                    $scope.load();
                                }, function (error) {
                                    errors.showError(error);
                                });
                            }
                        });

                    });

                };

                $scope.saveIndex = function () {
                    var key = $scope.key;
                    if ($scope.key == "OU") {
                        key = $scope.editableCollection.tipo === "DocumentType" ? "OUD" : "OUC";
                    }
                    dbaService.modify(key, $scope.id, $scope.editableIndex).then(function (result) {
                        errors.showSuccess('ModifyIndexSucces');
                        $scope.collections = null;
                        $scope.load();
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.goBack = function () {
                    $state.goBack();
                };

                $scope.load();
            }
        ]);
})();
